export var getChartSettings = function getChartSettings(state) {
  return state.chartSettings;
};